import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { Mail, AudioLines } from 'lucide-react'; // Removed FileText since Documents tab is gone
import EmployeeRequests from '../../components/Requests';
import Documents from '../../components/Documents'; // Keep for now if you plan to use elsewhere
import PageHeader from '../../components/headers/Header';
import DocumentDetailsModal from '../../components/DViews/DocDetailsModal';
import RequestEmployee from '../../components/RequestEmployee';

import './Requests.css';

// api
import { getAllDocuments, createDocument } from '../../services/documentAPIs';
import { getAllEmployees } from '../../services/HRstaff';

import { useMediaQuery, Fab, Typography, Box } from '@mui/material';

const DocRequestManagement = () => {
  const location = useLocation();
  const isEmployee = localStorage.getItem('userRole') === 'EMPLOYEE';
  const [employees, setEmployees] = useState([]);
  const [documents, setDocuments] = useState([]); // Still kept in case needed for modals or future use
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const isLargeScreen = useMediaQuery('(min-width: 1600px)');
  const [activeTab, setActiveTab] = useState(location.state?.activeTab || (isEmployee ? 'myRequests' : 'requests'));
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);

  useEffect(() => {
    if (location.state?.activeTab) {
      setActiveTab(location.state.activeTab);
    }
  }, [location.state]);

  // Fetch employees and documents on mount
  const fetchData = async () => {
    setLoading(true);
    try {
      const [employeeData, documentData] = await Promise.all([
        getAllEmployees(),
        getAllDocuments(),
      ]);
      console.log('Fetched Documents:', documentData);
      console.log('Employees', employeeData);
      setEmployees(employeeData);
      setDocuments(documentData);
    } catch (err) {
      setError('Failed to load data. Please try again.');
      console.error('Error fetching data:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleDocSelect = (doc) => {
    setSelectedDoc(doc);
    console.log('Selected document:', doc);
  };

  return (
    <div className="Leaves-main-container">
      <div className="Leaves-content-wrapper">
        {/* <PageHeader title={"Employee Requests"} subtitle={"Manage employee requests"} /> */}

        <div className="Leaves-nav-tabs">
          <div className="Leaves-tab-bar">
            {[
              // { id: 'overview', name: 'Overview', icon: AudioLines },
              { id: 'requests', name: 'Requests', icon: Mail },
              // REMOVED: { id: 'documents', name: 'Documents', icon: FileText },
              { id: 'myRequests', name: 'My Requests', icon: Mail }, // Reused Mail icon, or use another if preferred
            ].map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`Leaves-tab-btn ${activeTab === tab.id ? 'Leaves-tab-btn-active' : ''}`}
              >
                <tab.icon className="Leaves-tab-icon" />
                {tab.name}
              </button>
            ))}
          </div>
        </div>

        {activeTab === 'overview' && <></>}

        {activeTab === 'requests' && (
          <EmployeeRequests
            employees={employees}
            selectedDoc={selectedDoc}
            setSelectedDoc={setSelectedDoc}
            onDocSelect={handleDocSelect}
            setActiveTab={setActiveTab}
            setIsEditMode={setIsEditMode}
          />
        )}

        {/* REMOVED ENTIRE BLOCK:
        {activeTab === 'documents' && (
          <Documents
            selectedDoc={selectedDoc}
            setSelectedDoc={setSelectedDoc}
            onDocSelect={handleDocSelect}
            employees={employees}
            setEmployees={setEmployees}
            documents={documents}
            setDocuments={setDocuments}
            loading={loading}
            setLoading={setLoading}
            fetchDocuments={fetchData}
          />
        )}
        */}

        {selectedDoc && (
          <DocumentDetailsModal
            selectedDocument={selectedDoc}
            setSelectedDocument={setSelectedDoc}
            fetchDocuments={fetchData}
            isEditMode={isEditMode}
            setIsEditMode={setIsEditMode}
          />
        )}

        {activeTab === 'myRequests' && <RequestEmployee />}
      </div>
    </div>
  );
};

export default DocRequestManagement;